export default __webpack_public_path__ + "static/media/Debunking-the-Mystery.1a128cf4.jpg";